module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slate-int-custom-button"
    }
  }, [_c('span', {
    staticClass: "internal",
    class: {
      isValid: _vm.valid
    },
    on: {
      "click": _vm.customButtonClick
    }
  }, [_vm._t("default", [_vm._v("Default")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/template-compiler.js?id=data-v-0a304a4c!/Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/vue-loader/lib/selector.js?type=template&index=0!/Users/andrewkahn/Documents/experiments/slate-interactives/src/components/slate-int-custom-button/src/CustomButton.vue
// module id = 105
// module chunks = 0